import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import UdpView from '../views/UdpView.vue'
import TcpView from '../views/TcpView.vue'
import UdpdemoView from '../views/UdpdemoView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/udp',
    name: 'udp',
    component: UdpView
  },
  {
    path: '/tcp',
    name: 'tcp',
    component: TcpView
  },
  {
    path: '/udpdemo',
    name: 'udpdemo',
    component: UdpdemoView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
